// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"_23dW0hGV","resultsPane":"_20GywGE5","suggestionButton":"_2IDOZG9k","openUp":"_2O398TUC","typeAheadSurround":"_15hEJG5X"};